module.exports = "<div>\n    The Demo Component\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./source/components/demo-component/demo-component.html
// module id = 417
// module chunks = 0